const Badge = ({
  children = null,
  active = false,
  color = "purple",
  customColor = null,
  className = null,
  isButton = true,
  onClick = null,
}) => {
  // If customColor is provided, use custom styling
  if (customColor) {
    const baseClasses =
      "inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ring-1 ring-inset bg-white";
    const customClasses = `text-${customColor} ring-${customColor}`;

    return (
      <>
        {isButton ? (
          <button
            className={`${baseClasses} ${customClasses} ${className}`}
            onClick={onClick}
          >
            {children}
          </button>
        ) : (
          <span
            className={`${baseClasses} ${customClasses} ${className}`}
            onClick={onClick}
          >
            {children}
          </span>
        )}
      </>
    );
  }

  // Default behavior with standard Tailwind colors
  return (
    <>
      {isButton ? (
        <button
          className={`inline-flex items-center rounded-full bg-${color}-50 px-2 py-1 text-xs font-medium text-${color}-700 ring-1 ring-inset ring-${color}-700${active ? "" : "/10"} ${className}`}
          onClick={onClick}
        >
          {children}
        </button>
      ) : (
        <span
          className={`inline-flex items-center rounded-full bg-${color}-50 px-2 py-1 text-xs font-medium text-${color}-700 ring-1 ring-inset ring-${color}-700${active ? "" : "/10"} ${className}`}
          onClick={onClick}
        >
          {children}
        </span>
      )}
    </>
  );
};

export { Badge };
